export function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}

export const setStorageValue = (key, value) => {
    if (storageAvailable('localStorage'))
    {
        window.localStorage.setItem("--doko-tg-" + key, value)
    }
    if (storageAvailable('sessionStorage'))
    {
        window.sessionStorage.setItem("--doko-tg-" + key, value)
    }
}

export const getStorageValue = key => {
    if (storageAvailable('sessionStorage') && window.sessionStorage.getItem("--doko-tg-" + key))
    {
        const val = window.sessionStorage.getItem("--doko-tg-" + key)
        return val != undefined ? val : StorageFieldDefaults[key]
    }
    if (storageAvailable('localStorage'))
    {
        const val = window.localStorage.getItem("--doko-tg-" + key)
        return val != undefined ? val : StorageFieldDefaults[key]
    }
}

export const StorageFields = {
    CARD_STYLE: "card-style",
    BACKGROUND_STYLE: "background-style",
    PLAYER_NAME: "player-name",
    FADE_MENU: "fade-menu",
    ALLOW_CHAT: "allow-chat",
    NOTIFICATIONS: "notifications",
    PRE_MOVES: "pre-moves",
}

export const StorageFieldDefaults = {
    [StorageFields.CARD_STYLE]: "alt",
    [StorageFields.BACKGROUND_STYLE]: "fsr",
    [StorageFields.PLAYER_NAME]: "",
    [StorageFields.FADE_MENU]: "true",
    [StorageFields.ALLOW_CHAT]: "everyone",
    [StorageFields.NOTIFICATIONS]: "enabled",
    [StorageFields.PRE_MOVES]: "natural"
}